const XLogo = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<path
				d='M13.7125 10.6219L20.4134 3H18.8253L13.0072 9.61781L8.35999 3H3L10.0274 13.0074L3 21H4.58805L10.7324 14.0114L15.64 21H21L13.7121 10.6219H13.7125ZM11.5375 13.0955L10.8254 12.099L5.16018 4.16972H7.59931L12.171 10.569L12.883 11.5655L18.826 19.8834H16.3872L11.5375 13.0959V13.0955Z'
				fill='#21242D'
			/>
		</svg>
	);
};

export default XLogo;
